import type React from 'react';
import clsx from 'clsx';

const variants = {
  1: (
    <>
      <path className="fill-zinc-100" d="M0 0h156v156H0z"></path>
      <path
        className="fill-emerald-500"
        d="M129.486 156H156V0h-53.961c1.982 11.358 6.663 21.346 13.702 27.5l.757.662c14.837 12.97 19.241 42.948 9.84 66.953l-.479 1.223c-7.923 20.231-6.041 44.702 3.627 59.662z"
      />
      <path
        className="fill-zinc-800"
        d="M40.734 156H0V76.867C21.271 90.92 36.97 120.477 40.734 156z"
      />
    </>
  ),

  2: (
    <>
      <path className="fill-zinc-100" d="M0 0h156v156H0z" />
      <path className="fill-orange-400" d="M0 0c40 20 60 60 70 100s40 56 86 56H0V0z" />
      <path className="fill-zinc-800" d="M156 50c-40 10-70-10-100 10s-20 60-56 96h156V50z" />
    </>
  )
} as const;

interface PlaceholderImageProps extends React.ComponentPropsWithoutRef<'svg'> {
  variant?: keyof typeof variants;
}

export function PlaceholderImage({ variant = 1, ...props }: PlaceholderImageProps) {
  return (
    <svg
      className={clsx('size-full', props.className)}
      preserveAspectRatio="none"
      viewBox="0 0 156 156"
    >
      {variants[variant]}
    </svg>
  );
}
